//хук валидации фильтров грида для поиска всех позиций в плагинах для материальных отчетов для множественного выбора
//ref #94787 Добавить множественный выбор в некоторые плагины. 

import { useMemo } from 'react';
import { useTabsContext } from '../providers/tabsProvider';

interface IGridColumnFilter {
    name: string;
    operator: string;
    value: any;
}

interface GridFilter {
    expression?: string;
    columnFilters?: IGridColumnFilter[];
}

interface UseGridFilterValidation {
    isSearchModeExpression: boolean;
    isSearchModeColumnFilter: boolean;
    hasFilter: boolean;
}

const MIN_SEARCH_LENGTH = 3;

export const useGridFilterValidation = (gridFilter: GridFilter): UseGridFilterValidation => {
    const tabsContext = useTabsContext();
    
    const isValidExpression = (expression: any): boolean => {
        return expression !== undefined &&
            expression !== null &&
            expression !== '' &&
            typeof expression === 'string' &&
            expression.trim().length >= MIN_SEARCH_LENGTH;
    };

    const isValidColumnFilter = (columnFilters: IGridColumnFilter[]): boolean => {
        return Array.isArray(columnFilters) && 
               columnFilters.some(cf => cf.name && cf.name !== 'deleted');
    };

    const isSearchModeExpression = useMemo(() => 
        isValidExpression(gridFilter?.expression), 
        [gridFilter?.expression]
    );

    const isSearchModeColumnFilter = useMemo(() => 
        isValidColumnFilter(gridFilter?.columnFilters || []), 
        [gridFilter?.columnFilters]
    );

    const hasFilter = useMemo(() => {
        //ref #102435
        // Для плагина user_local_plugin всегда возвращаем true (пользователи - контрагенты)
        if (tabsContext.currentTab?.plugin === 'user_local_plugin') {
            return true;
        }
        
        return isSearchModeColumnFilter || isSearchModeExpression;
    }, [isSearchModeColumnFilter, isSearchModeExpression, tabsContext.currentTab?.plugin]);

    return {
        isSearchModeExpression,
        isSearchModeColumnFilter,
        hasFilter
    };
};